import config from "../config";

export const useConfig = () => {
  return config
}